/**
The main entry point for Press.
Referenced by page.press.liquid templates.
* */

/* eslint-disable no-unused-vars, max-len */
import React from 'react';
import ReactDOM from 'react-dom';
import OVApp from './utils/OVContext';
import Press from './components/Press';
import { jsx as _jsx } from "react/jsx-runtime";
ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(Press, {
    contactEmail: "press@outdoorvoices.com",
    title: "In the news."
  })
}), document.getElementById('press'));